export enum ITransitionPhase {
	enterStart = 'enterStart',
	enterFinish = 'enterFinish',
	exitStart = 'exitStart',
	beforeExitFinish = 'beforeExitFinish',
	exitFinish = 'exitFinish',
	hidden = 'hidden',
}